import { render, staticRenderFns } from "./DialogCategory.vue?vue&type=template&id=96c1685a"
import script from "./DialogCategory.vue?vue&type=script&lang=js"
export * from "./DialogCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports